import { useEffect, useState } from 'react';
import databaseMonitorService, { UserInfo } from '../../../../../services/databaseMonitor.service';

export function UsersView({ serverId }: { serverId: string }) {
  const [users, setUsers] = useState<UserInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    setUsers([]);
    databaseMonitorService
      .getUsers(serverId, controller.signal)
      .then((d) => {
        setUsers(d);
        setLoading(false);
      })
      .catch((err: any) => {
        if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;
        setError(err?.response?.data?.detail ?? err?.message ?? 'Failed to load users');
        setLoading(false);
      });
    return () => controller.abort();
  }, [serverId]);

  if (loading) return <div className="text-slate-600 dark:text-slate-400">Loading…</div>;
  if (error) return <div className="text-red-600 dark:text-red-400">Error: {error}</div>;

  return (
    <div className="flex flex-col gap-2">
      {users.map((u) => {
        const key = `${u.user}@${u.host}`;
        const isOpen = open === key;
        return (
          <div key={key} className="border border-slate-200 dark:border-slate-800 rounded-md">
            <button
              className="w-full flex items-center justify-between px-4 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-900/60"
              onClick={() => setOpen(isOpen ? null : key)}
            >
              <div className="text-sm text-slate-900 dark:text-slate-100">{key}</div>
              <span className="text-slate-500 dark:text-slate-500 text-xs">
                {u.grants.length} grant{u.grants.length === 1 ? '' : 's'} {isOpen ? '▾' : '▸'}
              </span>
            </button>
            {isOpen && (
              <div className="border-t border-slate-200 dark:border-slate-800 p-3 space-y-1">
                {u.grants.length === 0 ? (
                  <div className="text-xs text-slate-500 dark:text-slate-500">No grants returned.</div>
                ) : (
                  u.grants.map((g, i) => (
                    <pre
                      key={i}
                      className="text-xs whitespace-pre-wrap break-all bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-900 rounded px-2 py-1 text-slate-900 dark:text-slate-100"
                    >
                      {g}
                    </pre>
                  ))
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default UsersView;
